export default "__VITE_ASSET__Dhndyfpv__"